













































import { Component, Prop, Vue } from "vue-property-decorator";
import DashCard from "@/components/app/shared/cards/dash-card.vue";
import { ITelemetryNetworkInterface } from "@/@types/servers/telemetry";

@Component({
  components: { DashCard },
})
export default class NetworkCard extends Vue {
  @Prop({ type: Array, default: () => [] })
  readonly interfaces!: ITelemetryNetworkInterface[];

  get activeInterfaces(): ITelemetryNetworkInterface[] {
    return this.interfaces.filter(
      (i) => i.rx_bytes_per_sec > 0 || i.tx_bytes_per_sec > 0
    );
  }

  formatSpeed(bytesPerSec: number): string {
    if (bytesPerSec >= 1048576) {
      return (bytesPerSec / 1048576).toFixed(1) + " MB/s";
    }
    if (bytesPerSec >= 1024) {
      return (bytesPerSec / 1024).toFixed(1) + " KB/s";
    }
    return bytesPerSec.toFixed(0) + " B/s";
  }

  formatBytes(bytes: number): string {
    if (bytes === 0) return "0 B";
    const gb = bytes / (1024 * 1024 * 1024);
    if (gb >= 1) return gb.toFixed(2) + " GB";
    const mb = bytes / (1024 * 1024);
    if (mb >= 1) return mb.toFixed(1) + " MB";
    const kb = bytes / 1024;
    return kb.toFixed(1) + " KB";
  }
}
